import React, { FunctionComponent } from 'react';
import { ArrowBackIcon } from '@lyse-as/formds-react/lib/icon/common';

import { useLogoutMutation } from 'src/api/@generated/backend-api';

import { useFetchTokenMutation } from 'src/api/authentication-api/authentication-api';
import logoHorizontal from 'src/resources/logo-desktop.svg';
import logoVertical from 'src/resources/logo-mobile.svg';
import { NavigationService, navigationService } from 'src/services/navigation-service';
import { i18n } from 'src/i18n';
import { useLargeTabletMediaQuery } from 'src/utils/breakpoints-utils';
import { config } from 'src/config/config';

import {
  StyledButton,
  StyledHeader,
  StyledHeaderContainer,
  StyledLink,
  StyledLinkText,
  StyledLogo,
} from './header.styled';

export const Header: FunctionComponent = () => {
  const [, { isSuccess: isAuthenticated }] = useFetchTokenMutation();
  const [logout] = useLogoutMutation();

  const handleLogout = () => {
    navigationService.goToPath(NavigationService.LOGOUT);

    return (
      logout()
        .unwrap()
        /* eslint-disable-next-line no-console */
        .catch(() => console.warn('Failed to logout'))
        .finally(() => {
          navigationService.goToMainPage();
        })
    );
  };

  const isOnLargeTablet = useLargeTabletMediaQuery();

  const logo = isOnLargeTablet ? logoHorizontal : logoVertical;

  return (
    <StyledHeader>
      <StyledHeaderContainer>
        <StyledLink href={config.MAIN_PAGE}>
          <ArrowBackIcon />
          <StyledLinkText variant="uiText3" component="p">
            {i18n.component.header.linkToMainPage}
          </StyledLinkText>
        </StyledLink>
        <StyledLogo src={logo} alt={i18n.image.logo} />
        {isAuthenticated && (
          <StyledButton data-theme="dark" scheme="primary" variant="text" onClick={handleLogout}>
            {i18n.component.header.logoutButton}
          </StyledButton>
        )}
      </StyledHeaderContainer>
    </StyledHeader>
  );
};
